import { type QueryKey } from '@tanstack/react-query';

export const accountScopedQueryKeyHash = (queryKey: QueryKey): string => {
  // Get current account ID for cache isolation
  let accountId = null;

  // Priority 1: Check if AccountContextProvider has set the current account
  if (window.__VITAL_CURRENT_ACCOUNT__?._id) {
    accountId = window.__VITAL_CURRENT_ACCOUNT__._id;
  } else {
    // Priority 2: Extract from current URL
    const currentUrl = window.location.pathname;
    const accountMatch = currentUrl.match(/\/accounts\/([a-f0-9]{24})/);
    if (accountMatch) {
      [, accountId] = accountMatch;
    }
  }

  // Scope query keys by account to prevent cache bleeding
  const accountScopedKey = accountId ? [accountId, ...queryKey] : queryKey;
  return JSON.stringify(accountScopedKey);
};
